import { render, staticRenderFns } from "./FinalModal.vue?vue&type=template&id=38622ef5&scoped=true"
import script from "./FinalModal.vue?vue&type=script&lang=js"
export * from "./FinalModal.vue?vue&type=script&lang=js"
import style0 from "./FinalModal.vue?vue&type=style&index=0&id=38622ef5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38622ef5",
  null
  
)

export default component.exports